// extracted by mini-css-extract-plugin
module.exports = {"className":"fa-IR_className___2Q2Z"};